const AllApis = {
  users: {
    login: "/auth/login",
    getUserDetails: "/auth/getUser",
  },
  purchaseOrder: {
    add: "/purchase-order/create/PO",
    list: "/purchase-order/list",
  },
  sskCompany: {
    add: "/sskcompany",
    list: "/sskcompany/getAllCompany",
    sskCompanyById: function (companyId) {
      return `/sskcompany/${companyId}`;
    },
    edit: function (companyId) {
      return `/sskcompany/${companyId}`;
    },
    setPrimaryBranch: function (companyId, branchId) {
      return `/sskcompany/primaryBranch/${companyId}/${branchId}`;
    },
    dropdown: "/sskcompany/dropdown/list",
    branch: {
      add: "/sskcompany/branch",
      getBranchByCompanyId: function (companyId) {
        return `/sskcompany/branch/dropdown/list/${companyId}`;
      },
      edit: function (companyId, branchId) {
        return `/sskcompany/branch/${companyId}?branchId=${branchId}`;
      },
      list: "/sskcompany/BranchSskcompany/all",
      uploadFile: function (campanyId, branchId) {
        return `/sskcompany/branch/upload/${campanyId}/${branchId}`;
      },
    },
    contact: {
      add: function (campanyId, branchId) {
        return `/sskcompany/branch/contact/${campanyId}/${branchId}`;
      },
      edit: function (campanyId, branchId, contactId) {
        return `/sskcompany/branch/contact/${campanyId}/${branchId}?contactId=${contactId}`;
      },
      setPrimary: function (companyId, branchId, contactId) {
        return `/sskcompany/contact/setprimary/${companyId}/${branchId}?contactId=${contactId}`;
      },
    },
  },
  product: {
    dropdown: "/product/getProductList",
  },
  offlinestore: {
    add: "/myProfile",
    list: "/myProfile/getAllCompany",
    edit: function (companyId) {
      return `/myProfile`;
    },
    getBranchByCompanyId: function (companyId) {
      return `/myProfile/branch/dropdown/list`;
    },
    setPrimaryBranch: function (branchId) {
      return `/myProfile/primaryBranch/${branchId}`;
    },
    dropdown: "/myProfile/dropdown/list",
    branch: {
      add: "/myProfile/branch",
      edit: function (branchId) {
        return `/myProfile/branch/?branchId=${branchId}`;
      },
      list: "/myProfile/BranchOfflineStore/all",
      uploadFile: function (branchId) {
        return `/myProfile/branch/upload/${branchId}`;
      },
    },
    contact: {
      add: function (branchId) {
        return `/myProfile/branch/contact/${branchId}`;
      },
      edit: function (branchId, contactId) {
        return `/myProfile/branch/contact/${branchId}?contactId=${contactId}`;
      },
      setPrimary: function (branchId, contactId) {
        return `/myProfile/contact/setprimary/${branchId}?contactId=${contactId}`;
      },
    },
  },
  addressDropdown: {
    get: function (type) {
      return `/address/dropdown/get/${type}`;
    },
  },
  salesOrder: {
    list: "/confirm-sales/List",
    orderNoFromSales: "/confirm-sales/orderNoFromSales/dropdown/offlinestores",
  },
  faq: {
    list: "/faq/list",
  },
  inventory: {
    list: "/inventory/list",
  },
};
export default AllApis;
